import axios from 'axios';

export const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  // Nếu đang chạy trên trình duyệt (client-side) trên Domain / VPS (không phải localhost)
  // và envUrl không có hoặc bị trỏ nhầm về localhost/127.0.0.1 -> tự động fallback sang relative path '/api'
  if (
    typeof window !== 'undefined' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  ) {
    if (!envUrl || envUrl.includes('localhost') || envUrl.includes('127.0.0.1')) {
      return '/api';
    }
  }
  return envUrl || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5001/api');
};

const API_BASE_URL = getApiBaseUrl();

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 20000,
});

// Request Interceptor: Tự động đính kèm JWT Bearer Token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('lms_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Chuẩn hóa dữ liệu trả về và bắt lỗi xác thực
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Nếu hết hạn token hoặc không hợp lệ, xóa token cũ
      const currentPath = window.location.pathname;
      if (currentPath.startsWith('/learn') || currentPath.startsWith('/dashboard') || currentPath.startsWith('/quiz')) {
        localStorage.removeItem('lms_token');
        localStorage.removeItem('lms_user');
      }
    }
    const customError = {
      message: error.response?.data?.error?.message || error.response?.data?.message || 'Đã có lỗi xảy ra',
      code: error.response?.data?.error?.code || 'ERROR',
      statusCode: error.response?.status || 500,
      details: error.response?.data?.error?.details || null,
    };
    return Promise.reject(customError);
  }
);
